import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import PartnerStrip from "@/components/PartnerStrip";
import AppShowcase from "@/components/AppShowcase";
import Audience from "@/components/Audience";
import Coordinator from "@/components/Coordinator";
import Features from "@/components/Features";
import HealthStore from "@/components/HealthStore";
import HowItWorks from "@/components/HowItWorks";
import SOS from "@/components/SOS";
import Testimonials from "@/components/Testimonials";
import BetaSignup from "@/components/BetaSignup";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { siteContent } from "@/content/site";

export default function LandingPage() {
  useEffect(() => {
    document.title = siteContent.seo.title;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", siteContent.seo.description);
  }, []);

  return (
    <main data-testid="landing-page" className="relative bg-[#F4FAF8]">
      <Navbar />
      <Hero />
      <PartnerStrip />
      <AppShowcase />
      <Audience />
      <Coordinator />
      <Features />
      <HealthStore />
      <HowItWorks />
      <SOS />
      <Testimonials />
      <BetaSignup />
      <Contact />
      <Footer />
    </main>
  );
}
